module.exports = __webpack_public_path__ + "img/newStickerPic.c77be8ee.png";